import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-enterprise";
import Breadcrumb from '../../shared/breadcomeTitle/Breadcrumb';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import DailyReportsServices from '../../services/axiosServices/apiServices/DailyReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';
import moment from 'moment';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { CommonValidationMessages } from '../../utils/Messages';
import { getFinancialYearDates } from '../../utils/DateUtils';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class GeneralPurchaseRegister extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isTable2Expanded: false,
            isTable3Expanded: false,
            rowData: [],
            colDefs: [],
            rowHeight: 40,
            routes: [
                { path: "daily-reports", title: "Daily reports" },
                { path: "general-purchase-register", title: "General purchase register", previousPath: "daily-reports" },
            ],
            idCompany: 0,
            requestDetails: {
                fromDate: "",
                toDate: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
            }
        };
    }
    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.requestDetails;
        if (name === "fromDate") {
            details[name] = value
        } else {
            details[name] = value
        }
        this.setState({ requestDetails: details });
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                //this.usp_Reports_TAXSummary_ALLRecords();
            });
        } else {
            //window.location.href = "/Login";
        } setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);

        let details = this.state.requestDetails
        details.fromDate = getFinancialYearDates().fromDate;
        details.toDate = getFinancialYearDates().toDate;
        this.setState({ requestDetails: details })
    }
    componentDidUpdate(prevState) {
        if (prevState.rowData !== this.state.rowData) {
            const newSumRow = this.calculateSumRow();
            if (JSON.stringify(this.state.sumRow) !== JSON.stringify(newSumRow)) {
                this.setState({ sumRow: newSumRow });
            }
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    usp_Reports_TAXSummary_ALLRecords = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = {
                idCompany: this.state.idCompany,
                fromDate: this.state.requestDetails.fromDate,
                toDate: this.state.requestDetails.toDate
            };
            //let idCompany = this.state.idCompany;
            // debugger;
            this.dailyReportsServices.usp_Reports_TAXSummary_ALLRecords(request).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 2,
                            filter: true,
                            floatingFilter: true,
                            valueFormatter: key.includes("invoiceDate") || key.includes("inwardDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : key.includes("grossAmount")
                                    ? (params) => params.value ? parseFloat(params.value).toFixed(2) : ""
                                    : null,
                            pinned: ["inwardNo", "inwardDate", "vendor"].includes(key) ? "left" : null,
                            width: this.getPinnedWidth(key),
                        }
                        ));
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                        }, () => {
                            this.setState({ sumRow: this.calculateSumRow() });
                        });
                    }
                    //debugger;
                    //let data = response.responseItem.responseContent;
                    //this.setState({ rowData: data }, () => {
                    //let data = this.state.userDetails;
                    //data.databaseName = databasename;
                    //this.setState({ rowData: data })
                    //this.goToNextStep()
                    //});
                }
            });
        }
    }
    getColumnWidth = (key) => {
        const columnWidth = {
            "inwardNo": window.innerWidth * 0.06,
            "inwardDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.18,
            "gstNo": window.innerWidth * 0.1,
            "invoiceNo": window.innerWidth * 0.05,
            "invoiceDate": window.innerWidth * 0.07,
            "inwardFrom": window.innerWidth * 0.11,
            "idPartyAccount": window.innerWidth * 0.06,
            "totalQty": window.innerWidth * 0.05,
            "grossAmount": window.innerWidth * 0.1,
        }
        return columnWidth[key];
    }
    getPinnedWidth = (key) => {
        const pinnedWidth = {
            "inwardNo": window.innerWidth * 0.06,
            "inwardDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.2,
        }
        return pinnedWidth[key];
    }

    calculateSumRow = () => {
        const { rowData } = this.state;
        return {
            inwardNo: "Total",
            grossAmount: parseFloat(rowData.reduce((sum, row) => sum + (row.grossAmount || 0), 0)).toFixed(2),
            totalCgst: parseFloat(rowData.reduce((sum, row) => sum + (row.totalCgst || 0), 0)).toFixed(2),
            totalSgst: parseFloat(rowData.reduce((sum, row) => sum + (row.totalSgst || 0), 0)).toFixed(2),
            totalIgst: parseFloat(rowData.reduce((sum, row) => sum + (row.totalIgst || 0), 0)).toFixed(2),
        };
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.requestDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    render() {
        return (
            <div className='general-purchase-register'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[60%] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select date</p>
                            <div className='item-grp flex gap-[10px] items-end'>
                                <div className='input-grp w-full'>
                                    <label>From date</label>
                                    <input type='date' className={`px-[10px] py-[5px] ${this.state.validState.error.fromDate !== undefined ? "error" : ""}`}
                                        onChange={(event) => this.handleChange(event, "fromDate")}
                                        id='fromDate' name='fromDate'
                                        value={this.state.requestDetails.fromDate}
                                    />
                                </div>
                                <div className='input-grp w-full'>
                                    <label>To date</label>
                                    <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`}
                                        onChange={(event) => this.handleChange(event, "toDate")}
                                        id='toDate' name='toDate'
                                        value={this.state.requestDetails.toDate}
                                    />
                                </div>
                                <button className='prm-btn h-fit ml-[10px]'
                                    onClick={() => { this.usp_Reports_TAXSummary_ALLRecords() }}
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[72vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">General purchase register</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    headerHeight={65}
                                    columnDefs={this.state.colDefs}
                                    rowSelection={this.rowSelection}
                                    pinnedBottomRowData={[this.state.sumRow]}
                                    rowClassRules={{
                                        "sum-row": (params) => params.node.rowPinned === "bottom"
                                    }}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default GeneralPurchaseRegister;